<template>
	<ProcessCreatePage>
		<Header :title="$t('new_comprehensive_insurance').toString()">
			{{ $t('create_document_information') }}
		</Header>

		<div class="main">
			<div class="flex space-x-8">
				<BaseSelect class="w-full" :required="true" v-model="status" :options="comprehensiveOppositeInsuranceStatus" label="Status" />
			</div>
			<div class="flex space-x-4">
				<BaseInput class="w-full" v-model="oppositeCaseNumber" :label="$t('case_number')" />
				<BaseInput class="w-full" v-model="oppositeInsuranceContractNumber" :label="$t('contract_number')" />
			</div>

			<CompanyForm
				ref="CompanyForm"
				v-if="isInsuranceKnown"
				v-model="model"
				:options="options"
				:custom-label="$t('foreign_insurance').toString()"
				:options-label="$t('insurance').toString()"
				:highlight_suffix="$t('add_new')"
        :show-postal-options="true"
			/>
		</div>

		<Footer
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="false"
			:is-back-button="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import BaseInput from '@/components/forms/inputs/BaseInput';
import CompanyForm from '@/components/damagecases/forms/CompanyForm';
import Validate from '@/mixins/Validate';
import { InsurancesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import OppositeInsuranceStatus from '@/mixins/damagecase/OppositeInsuranceStatus';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ProcessCreateComprehensiveInsurance',
	components: { CompanyForm, BaseInput, BaseSelect, ProcessCreatePage, Header, Footer },
	mixins: [AppContainerMixin, Validate, OppositeInsuranceStatus],
	computed: {
		isInsuranceKnown() {
			return this.status === this.comprehensiveOppositeInsuranceStatus[0];
		},
	},
	data() {
		return {
			model: {
				city: {
					zipCode: null,
					name: null,
				},
			},
			options: [],
			status: null,
			oppositeCaseNumber: null,
			oppositeInsuranceContractNumber: null,
		};
	},
	methods: {
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$store.commit('setProcessCreateComprehensiveInsurance', this.isInsuranceKnown ? this.model : null);
				this.$store.commit('setProcessCreateComprehensiveOppositeInsuranceState', this.status.value);
				this.$store.commit('setProcessCreateComprehensiveOppositeCaseNumber', this.oppositeCaseNumber);
				this.$store.commit('setProcessCreateComprehensiveOppositeInsuranceContractNumber', this.oppositeInsuranceContractNumber);
				this.$emit('next');
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	mounted() {
		InsurancesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
			.insurancesGet()
			.then(res => {
				this.options = res.data.filter(x => x.is_system_insurance);
			})
			.catch(error => {
				this.$swal(this.$t('general.attention').toString(), this.$t('no_insurances_found').toString(), 'warning');
			});
	},
};
</script>
